import axios from 'axios';
import store from '../store';
import { logout } from '../store/authSlice';
import { toast } from 'react-toastify';

// Create an axios instance with common configuration
const baseURL = import.meta.env.MODE === 'development' ? import.meta.env.VITE_BASE_URL : '';
const api = axios.create({ baseURL });
// Add request interceptor for development delay
if (import.meta.env.MODE === 'development') {
    api.interceptors.request.use(
        config => {
            return new Promise(resolve => {
                setTimeout(() => resolve(config), 400);
            });
        }
    );
}
// Add response interceptor
api.interceptors.response.use(
    response => response,
    error => {
        // Handle token expiration or invalid token
        console.log('API error response:', error); // Debug log
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            // Check if the error message specifically indicates token expiration
            const isExpired = error.response.data &&
                (error.response.data.expired ||
                    error.response.data.code === 'token_expired' ||
                    error.response.data.message === 'Token expired');

            if (isExpired) {
                toast.error('Your session has expired. Please log in again.');
            } else {
                toast.error('Authentication error. Please log in again.');
            }

            // Dispatch logout action
            store.dispatch(logout());
        }
        return Promise.reject(error);
    }
);

// Add request interceptor to automatically add token to requests
api.interceptors.request.use(
    config => {
        const token = sessionStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

export default api;
